<template>
  <div class="icon-plus" :class="[{ selected: selected }]">
    <div class="icons">
      <i class="first-icon-plus" />
      <i class="second-icon-plus" />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'plus-icon',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
  },
});
</script>
<style lang="scss">
.selected {
  .icon-plus .icons .second-icon-plus {
    transform: rotate(90deg);
  }
}
</style>
<style lang="scss" scoped>
.icon-plus {
  width: 24px;
  min-width: 24px;
  height: 24px;

  .icons {
    position: relative;
    width: 100%;
    height: 100%;

    i {
      width: 18px;
      background: var(--secondary-bg-color);
      height: 1px;
      display: block;
      position: absolute;
      inset: 0 0 0 0;
      margin: auto;
    }

    .second-icon-plus {
      width: 1px;
      height: 18px;
      transition: transform 0.25s ease-in-out;
    }
  }

  &.selected .icons .second-icon-plus {
    transform: rotate(90deg);
  }
}
</style>
